import clsx from "clsx";

import Skeleton from "common/components/ui/Skeleton";
import { Tag } from "common/components/ui/Tag";

import useCampaignCompletion from "../../../datahooks/useCampaignCompletion";

interface ProgressTagProps {
  campaignId: string;
  size: "sm" | "md";
}

export default function ProgressTag({ campaignId, size }: ProgressTagProps) {
  const { completion, isLoadingCompletion } = useCampaignCompletion(campaignId);

  if (isLoadingCompletion) {
    return (
      <Skeleton className={clsx(size === "md" ? "h-6 w-12" : "h-5 w-10")} />
    );
  } else if (typeof completion === "number") {
    return (
      <Tag variant="tertiary" size={size}>
        {Math.floor(completion * 100)}%
      </Tag>
    );
  }
}
